import script from "./CreateMerchantDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateMerchantDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateMerchantDialog.vue?vue&type=style&index=0&id=6d1fc154&lang=css"
import "./CreateMerchantDialog.vue?vue&type=style&index=1&id=6d1fc154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1fc154"]])

export default __exports__